import React from 'react';
import { withI18n } from '@lingui/react';
import { Trans, t } from '@lingui/macro';
import Popup from './Popup';

function NewsletterPopup({ show, onClose, i18n }) {
  const [newsletterName, setNewsletterName] = React.useState('');
  const [newsletterEmail, setNewsletterEmail] = React.useState('');
  const [newsletterMessage, setNewsletterMessage] = React.useState('');
  const [isNewsletterSubmitting, setIsNewsletterSubmitting] = React.useState(false);
  const [newsletterSuccess, setNewsletterSuccess] = React.useState(false);
  const [newsletterError, setNewsletterError] = React.useState('');

  React.useEffect(() => {
    if (show) {
      setNewsletterName('');
      setNewsletterEmail('');
      setNewsletterMessage('');
      setNewsletterSuccess(false);
      setNewsletterError('');
    }
  }, [show]);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!newsletterName.trim() || !newsletterEmail.trim() || isNewsletterSubmitting) return;

    setIsNewsletterSubmitting(true);
    setNewsletterError('');

    try {
      const apiUrl = process.env.GATSBY_API_URL || '';
      const response = await fetch(`${apiUrl}/v1/notify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'show_signup',
          name: newsletterName.trim(),
          email: newsletterEmail.trim(),
          message: newsletterMessage.trim() || undefined,
          r: 'show260704',
          isContactForm: true,
        }),
      });

      if (response.ok) {
        setNewsletterSuccess(true);
      } else {
        setNewsletterError(i18n._(t`An error occurred. Please try again later.`));
      }
    } catch (err) {
      console.error(err);
      setNewsletterError(i18n._(t`An error occurred. Please try again later.`));
    } finally {
      setIsNewsletterSubmitting(false);
    }
  };

  return (
    <Popup
      className="newsletter-popup"
      show={show}
      withCloseBtn={false}
      onClose={onClose}
    >
      {newsletterSuccess ? (
        <div className="success-container">
          <svg className="success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div className="success-text" style={{ marginBottom: '25px' }}>
            <Trans>Thank you for signing up to Ada's newsletters!</Trans>
          </div>
          <button 
            onClick={onClose}
            style={{
              background: 'none',
              border: '2px solid rgba(0,0,0,0.2)',
              padding: '15px 45px',
              borderRadius: '45px',
              fontSize: '1.35rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              color: '#1a1a1a',
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif"
            }}
            onMouseOver={(e) => { e.target.style.backgroundColor = 'rgba(0,0,0,0.05)'; e.target.style.borderColor = 'rgba(0,0,0,0.4)' }}
            onMouseOut={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.borderColor = 'rgba(0,0,0,0.2)' }}
          >
            <Trans>Close</Trans>
          </button>
        </div>
      ) : (
        <>
          <div className="newsletter-title">
            <Trans>Stay in touch!</Trans>
          </div>
          <div className="newsletter-desc">
            <Trans>Please enter your name and email to stay in touch for all future Ada shows and music releases!</Trans>
          </div>
          <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
            <div className="input-group">
              <label htmlFor="newsletter-name"><Trans>Your Name</Trans></label>
              <input
                id="newsletter-name"
                type="text"
                name="name"
                autoComplete="name"
                required
                disabled={isNewsletterSubmitting}
                value={newsletterName}
                onChange={(e) => setNewsletterName(e.target.value)}
              />
            </div>
            <div className="input-group">
              <label htmlFor="newsletter-email"><Trans>Your Email</Trans></label>
              <input
                id="newsletter-email"
                type="email"
                name="email"
                autoComplete="email"
                required
                disabled={isNewsletterSubmitting}
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
              />
            </div>
            <div className="input-group">
              <label htmlFor="newsletter-message"><Trans>Message (optional)</Trans></label>
              <textarea
                id="newsletter-message"
                name="message"
                disabled={isNewsletterSubmitting}
                value={newsletterMessage}
                onChange={(e) => setNewsletterMessage(e.target.value)}
              />
            </div>
            {newsletterError && (
              <div style={{ color: '#ff5252', fontSize: '13px', textAlign: 'center', marginTop: '5px' }}>
                {newsletterError}
              </div>
            )}
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center', marginTop: '15px', flexWrap: 'wrap' }}>
              <button
                type="submit"
                className="submit-btn"
                disabled={isNewsletterSubmitting}
                style={{ margin: 0 }}
              >
                {isNewsletterSubmitting ? <Trans>Signing up...</Trans> : <Trans>Subscribe</Trans>}
              </button>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: 'none',
                  border: '2px solid rgba(0,0,0,0.2)',
                  padding: '15px 45px',
                  borderRadius: '45px',
                  fontSize: '1.35rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  color: '#1a1a1a',
                  fontFamily: "'Inter', 'Helvetica Neue', sans-serif"
                }}
                onMouseOver={(e) => { e.target.style.backgroundColor = 'rgba(0,0,0,0.05)'; e.target.style.borderColor = 'rgba(0,0,0,0.4)' }}
                onMouseOut={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.borderColor = 'rgba(0,0,0,0.2)' }}
              >
                <Trans>Close</Trans>
              </button>
            </div>
          </form>
        </>
      )}
    </Popup>
  );
}

export default withI18n()(NewsletterPopup);
